import React, { useMemo } from "react";
import { Input, InputDate, TextAreaInput } from "../Helpers/Input/Input";
import trans from "../../utils";
import { InputSelect } from "../Helpers/Input/RefactoredInput";
import { DatePicker, Space } from "antd";
import dayjs from "dayjs";
import { useGetAllCustomersQuery } from "../../Redux/service/Customer/Customer";
import Dropfile from "../Helpers/Dropzone/Dropzone";
import POIsLogo from "../POIs/POIsForm/Extra/POIsLogo";
import POIsAttachments from "../POIs/POIsForm/Extra/POIsAttachments";
import { useGetAllformsQuery } from "../../Redux/service/Forms/Form";

export default function ProjectsetupInfo({ addPOI, poiAttachments }) {
	const { data } = useGetAllCustomersQuery({ page: 1, limit: 10000 });

	const projectType = [
		{ label: "Buildings", value: "buildings" },
		{ label: "Infrastructure", value: "infrastructure" },
		{ label: "Roads", value: "roads" },
		{ label: "MEP", value: "MEP" },
		{ label: "MixedUse", value: "mixedUse" },
	];
	const projectStatus = [
		{ label: "Active", value: "active" },
		{ label: "On Hold", value: "onHold" },
		{ label: "Completed", value: "completed" },
		{ label: "Planning Phase", value: "planningPhase" },
	];
	const formCategory = [
		{ label: "IR", value: "IR" },
		{ label: "NCR", value: "NCR" },
		{ label: "MIR", value: "MIR" },
	];
	const { data: forms } = useGetAllformsQuery({
		page: 1,
		limit: 100000,
		queryString: `category=${addPOI.values.formCategory}&isActive=true`,
	});
	const startDateValue = useMemo(() => {
		return addPOI.values.startDate ? dayjs(addPOI.values.startDate) : null;
	}, [addPOI.values.startDate]);
	const endDateValue = useMemo(() => {
		return addPOI.values.endDate ? dayjs(addPOI.values.endDate) : null;
	}, [addPOI.values.endDate]);
	const disabledEndDate = useMemo(() => {
		if (!addPOI.values.startDate) return undefined;

		const start = dayjs(addPOI.values.startDate);

		return (current) => {
			if (!current) return false;
			return current.isSame(start, "day") || current.isBefore(start, "day");
		};
	}, [addPOI.values.startDate]);
	return (
		<div className="driverinfo mb-24">
			<p className="fs-16 fw-500 brand-700 text-capitalize">
				{trans("Project information")}
			</p>
			<div className="row">
				{/* Project Name */}
				<div className="col-lg-6">
					<Input
						title={trans("Project Name")}
						type="text"
						placeholder={trans("Enter project name")}
						id="name"
						name="name"
						formstyle="form-input"
						onBlur={addPOI.handleBlur}
						onChange={addPOI.handleChange}
						errors={addPOI.errors.name}
						touched={addPOI.touched.name}
						value={addPOI.values.name || ""}
					/>
				</div>

				{/* Project Type */}
				<div className="col-lg-6">
					<InputSelect
						label={trans("Project Type")}
						id="projectType"
						name="projectType"
						placeholder={trans("Select project type")}
						className="w-100"
						formstyle="form-input"
						options={projectType?.map((i) => ({
							label: trans(i?.label),
							value: i?.value,
						}))}
						onBlur={addPOI.handleBlur}
						onChange={(val) => addPOI.setFieldValue("projectType", val)}
						value={addPOI.values.projectType || undefined}
					/>
				</div>

				{/* Project Status */}
				<div className="col-lg-6">
					<InputSelect
						label={trans("Project Status")}
						id="projectStatus"
						name="projectStatus"
						placeholder={trans("Select project status")}
						className="w-100"
						formstyle="form-input"
						options={projectStatus?.map((i) => ({
							label: trans(i?.label),
							value: i?.value,
						}))}
						onBlur={addPOI.handleBlur}
						onChange={(val) => addPOI.setFieldValue("projectStatus", val)}
						value={addPOI.values.projectStatus || undefined}
					/>
				</div>
				<div className="col-lg-6">
					<InputSelect
						label="Form Category"
						id="formCategory"
						name="formCategory"
						placeholder={trans("Select form category")}
						className="w-100"
						formstyle="form-input"
						options={formCategory?.map((i) => ({
							label: trans(i?.label),
							value: i?.value,
						}))}
						errors={addPOI.errors.formCategory}
						touched={addPOI.touched.formCategory}
						onBlur={(e) => addPOI.handleBlur(e)}
						onChange={(val) => addPOI.setFieldValue("formCategory", val)}
						value={addPOI.values.formCategory ?? undefined}
					/>
				</div>
				<div className="col-lg-6">
					<InputSelect
						label="Form"
						id="forms"
						name="forms"
						placeholder={trans("Select form")}
						className="w-100"
						formstyle="form-input"
						options={forms?.data?.map((i) => ({
							label: i?.name,
							value: i?.id,
						}))}
						errors={addPOI.errors.forms}
						touched={addPOI.touched.forms}
						onBlur={(e) => addPOI.handleBlur(e)}
						onChange={(val) => addPOI.setFieldValue("forms", val)}
						value={addPOI.values.forms ?? undefined}
						disabled={!addPOI.values.formCategory}
					/>
				</div>
				{/* Description */}
				<div className="col-lg-12">
					<TextAreaInput
						title={trans("Description")}
						placeholder={trans("Enter project description")}
						id="notes"
						name="notes"
						formstyle="form-input mb-4"
						onBlur={addPOI.handleBlur}
						onChange={addPOI.handleChange}
						touched={addPOI.touched.notes}
						errors={addPOI.errors.notes}
						value={addPOI.values.notes || ""}
					/>
				</div>

				{/* Customer Name */}
				<div className="col-lg-6">
					<InputSelect
						label={trans("Customer Name")}
						id="contactPerson.name"
						name="contactPerson.name"
						placeholder={trans("Select customer")}
						className="w-100"
						formstyle="form-input"
						options={data?.data.map((i) => ({
							label: i?.name,
							value: i?.name,
						}))}
						onBlur={addPOI.handleBlur}
						onChange={(val) => addPOI.setFieldValue("contactPerson.name", val)}
						value={addPOI?.values.contactPerson?.name || undefined}
					/>
				</div>

				{/* Project Location */}
				<div className="col-lg-6">
					<Input
						title={trans("Project Location")}
						type="text"
						placeholder={trans("Enter project location")}
						id="address"
						name="address"
						formstyle="form-input"
						onBlur={addPOI.handleBlur}
						onChange={addPOI.handleChange}
						errors={addPOI.errors.address}
						touched={addPOI.touched.address}
						value={addPOI.values.address || ""}
					/>
				</div>

				{/* Start Date */}
				<div className="col-lg-6">
					<InputDate
						title={trans("Start Date")}
						id="startDate"
						name="startDate"
						onBlur={() => addPOI.setFieldTouched("startDate", true)}
						onChange={(value) => {
							const formattedDate = value
								? dayjs(value).format("YYYY-MM-DD")
								: "";
							addPOI.setFieldValue("startDate", formattedDate);

							// reset end date if start date is cleared
							if (!value) {
								addPOI.setFieldValue("endDate", "");
							}
						}}
						errors={addPOI.errors.startDate}
						touched={addPOI.touched.startDate}
						value={addPOI.values.startDate || ""}
					/>
				</div>

				{/* End Date */}
				<div className="col-lg-6">
					<InputDate
						title={trans("End Date")}
						id="endDate"
						name="endDate"
						disabled={!addPOI.values.startDate} // ✅ disabled if no start date
						onBlur={() => addPOI.setFieldTouched("endDate", true)}
						onChange={(value) => {
							const formattedDate = value
								? dayjs(value).format("YYYY-MM-DD")
								: "";
							addPOI.setFieldValue("endDate", formattedDate);
						}}
						errors={addPOI.errors.endDate}
						touched={addPOI.touched.endDate}
						value={addPOI.values.endDate || ""}
					/>
				</div>

				{/* Dropfile */}
				<div className="col-lg-12">
					<POIsAttachments addPOI={addPOI} poiAttachments={poiAttachments} />
				</div>

				{/* POIs Logo */}
				<div className="col-lg-12">
					<POIsLogo addPOI={addPOI} />
				</div>
			</div>
		</div>
	);
}
